import { badgesType, sellerLevelType } from '../../shared/types';

export default {
    sellerLevel: sellerLevelType.isRequired,
    badges: badgesType,
};
